import { aboutStats, siteMeta } from "@/mocks/daily";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "真实可溯源",
    desc: "信息多来自公开可查的话题，重要结论标注来源线索，不做无出处的主观臆测。",
  },
  {
    icon: "ri-dashboard-line",
    title: "速览不啰嗦",
    desc: "用榜单、合集与盘点把碎片热点结构化，让你在几分钟内读完一天的重点。",
  },
  {
    icon: "ri-community-line",
    title: "客观不站队",
    desc: "只整理呈现当日讨论趋势，不预设立场，把判断的空间留给读者。",
  },
  {
    icon: "ri-empathize-line",
    title: "热点有温度",
    desc: "大事之外，也关注那些打动人心的平凡瞬间，让快节奏里多一份暖意。",
  },
];

const quotes = [
  { text: "每天早上通勤时刷一遍精选，今天要聊的话题基本都能接上话了。", by: "读者 · 上班族" },
  { text: "热榜+盘点一起看，比自己在热搜里翻半天省心多了。", by: "读者 · 内容运营" },
  { text: "合集把同一件事讲得特别清楚，周末补课神器。", by: "读者 · 学生党" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        {/* 品牌与理念 */}
        <div className="grid gap-8 lg:grid-cols-2 lg:items-start">
          <div>
            <p className="text-xs font-semibold tracking-widest text-primary-600 uppercase">About Us</p>
            <h2 className="mt-2 font-serif text-2xl md:text-4xl font-black text-foreground-950">
              关于<span className="text-primary-500">本站</span>
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              {siteMeta.brand}是一家每日更新的热点资讯速览门户。我们每天把全网从娱乐八卦到社会民生的大小事件，按栏目整理成
              汇总、合集与盘点，让你「一次看够当日精彩」。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              我们相信，热点不该成为焦虑的噪音，而该是一份清晰、有序、可以快速读完的信息。这也是我们坚持用榜单、精选和时间线来呈现内容的原因。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href={`mailto:${siteMeta.tipsEmail}`}
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-send-line text-sm" aria-hidden="true"></i>
                投稿与合作
              </a>
              <a
                href="#faq"
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
              >
                阅读常见问题
              </a>
            </div>
          </div>

          {/* 数据指标 */}
          <div className="grid grid-cols-2 gap-4">
            {aboutStats.map((s) => (
              <div key={s.label} className="rounded-xl bg-background-50 border border-background-200 p-5 text-center">
                <p className="font-serif text-3xl md:text-4xl font-black text-foreground-950">
                  <span className="text-primary-500">{s.num}</span>
                  <span className="text-base font-bold text-foreground-600">{s.unit}</span>
                </p>
                <p className="mt-2 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 内容原则 */}
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div key={p.title} className="rounded-xl bg-background-50 border border-background-200 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-xl text-primary-600">
                <i className={p.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-3 font-serif text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {quotes.map((q) => (
            <figure key={q.by} className="rounded-xl bg-background-50 border border-background-200 p-5">
              <div className="flex text-accent-500" aria-hidden="true">
                {Array.from({ length: 5 }).map((_, k) => (
                  <i key={k} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{q.text}”</blockquote>
              <figcaption className="mt-3 text-xs text-foreground-500">{q.by}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}